(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/create-game/assets/javascripts/services/create-game.js') >= 0) return;  svs.modules.push('/components/marketplace-data/create-game/assets/javascripts/services/create-game.js');
"use strict";

const jupiter = svs.core.jupiter;
const createGame = (groupId, game, callback) => {
  const containerPayload = {
    name: game.name,
    productId: game.productId,
    drawNumber: game.drawNumber,
    maxSharesPerMember: game.maxFractionsPerMember,
    maxNumShares: game.maxFractionsPerGame,
    sharePrice: svs.utils.format.Currency(game.fractionPrice, true).replace(/\s/g, ''),
    buyinCloseTime: "".concat(dateFns.formatISO(new Date(game.buyStop)).split('.')[0], "Z"),
    drawDescription: game.description,
    description: game.description
  };
  jupiter.post({
    path: "/marketplace/1/groups/".concat(groupId, "/activateddraws"),
    data: containerPayload
  }, res => {
    callback(undefined, res.CreateActivatedDrawReply);
  }, error => {
    callback(error.responseJSON.error);
  });
};
setGlobal('svs.components.marketplaceData.createGame.services.createGame', createGame);

 })(window);